import store from "./store";

export function skipWaiting() {
  if (waitingServiceWorker) {
    waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
  }
}

let waitingServiceWorker = null;
export function register() {
  if (process.env.NODE_ENV === "production" && "serviceWorker" in window.navigator) {
    window.navigator.serviceWorker.addEventListener("controllerchange", () => {
      window.location.reload();
    });

    window.navigator.serviceWorker.register("/sw.js").then(registration => {
      console.log("Serivce Worker Initialized!");
      if (registration.waiting) {
        console.log("Serivce Worker Update Available!");
        waitingServiceWorker = registration.waiting;
        store.dispatch("updateAvailable");
      }

      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;
        console.log("Serivce Worker Update FOUND!", newWorker);
        if (newWorker.state === "installed") {
          console.log("New Version is READY TO GO!!!");
          waitingServiceWorker = newWorker;
          store.dispatch("updateAvailable");
        } else {
          console.log("New Version is installing, waiting for it to install...");
          newWorker.addEventListener("statechange", () => {
            console.log("New Version status updated!", newWorker.state);
            if (newWorker.state === "installed") {
              console.log("New Version INSTALLED AND READY TO GO!!!");
              waitingServiceWorker = newWorker;
              store.dispatch("updateAvailable");
            }
            if (newWorker.state === "activated") {
              console.log("New Version INSTALLED AND ACTIVATED!!!");
              window.location.reload();
            }
          });
        }
      });
    });
  }
}
